import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import React, { useEffect, useState } from 'react';
import { Button, IconSpinner } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';
import { InboxItem, txState } from '../InboxPage/InboxPage';

import css from './ListingPage.css';

const BOOKING_DATE = 'booking_date';
const CREATED_DATE = 'created_date';

const SectionBookingListMaybe = props => {
  const {
    transactions,
    unitType,
    intl,
    fetchInProgress,
    fetchTransactionsError,
    pagination,
    onLoadSeeMore,
  } = props;

  const [sortingType, setSortingType] = useState(BOOKING_DATE);

  const sortedTxsByCreatedDate = txs => reverse(
    sortBy(txs, tx => {
      return tx.attributes ? tx.attributes.transitions[0].createdAt : null;
    })
  )

  const sortedTxsByBookingDate = txs => reverse(
    sortBy(txs, tx => {
      return tx.booking && tx.booking.attributes ? tx.booking.attributes.start : null;
    })
  )
  const [sortedTransactions, setSortedTransactions] = useState([]);
  useEffect(() => {
    sortingType === BOOKING_DATE ?
      setSortedTransactions(sortedTxsByBookingDate(transactions))
      : setSortedTransactions(sortedTxsByCreatedDate(transactions))
  }, [transactions, sortingType]);

  const handleClickSortingByCreatedDate = () => {
    setSortedTransactions(sortedTxsByCreatedDate(transactions));
    setSortingType(CREATED_DATE);
  }

  const handleClickSortingByBookingDate = () => {
    setSortedTransactions(sortedTxsByBookingDate(transactions));
    setSortingType(BOOKING_DATE);
  }

  const toTxItem = (tx) => {
    const type = 'sale';
    const stateData = txState(intl, tx, type);

    // Render InboxItem only if the latest transition of the transaction is handled in the `txState` function.
    return stateData ? (
      <li key={tx.id.uuid} className={css.listItem}>
        <InboxItem unitType={unitType} type={type} tx={tx} intl={intl} stateData={stateData} />
      </li>
    ) : null;
  };
  const noResults =
    !fetchInProgress && transactions.length === 0 && !fetchTransactionsError ? (
      <li key="noResults" className={css.noResults}>
        <FormattedMessage id={'InboxPage.noSalesFound'} />
      </li>
    ) : null;

  const seeMoreBtn = pagination && pagination.totalPages > 1 && pagination.totalItems > transactions.length ? (
    <div className={css.rowSeeMoreBtn}>
      <span className={css.seeMoreBtn} onClick={onLoadSeeMore}>
        <FormattedMessage id={'ListingPage.seeMore'} />
      </span>
    </div>
  ) : null

  return (
    <div className={css.sectionBookings}>
      <div className={css.sectionBookingHeading}>
        <h2 className={css.bookingHeading}>
          <FormattedMessage id="ListingPage.bookingListHeading" values={{ count: pagination?.totalItems }} />
        </h2>
        <div className={css.row}>
          <Button
            className={sortingType === BOOKING_DATE ? css.selectedSorting : css.unselectedSorting}
            onClick={handleClickSortingByBookingDate}
          >
            <FormattedMessage id="ListingPage.sortingTypeBookingDate" />
          </Button>
          <Button
            className={sortingType === CREATED_DATE ? css.selectedSorting : css.unselectedSorting}
            onClick={handleClickSortingByCreatedDate}
          >
            <FormattedMessage id="ListingPage.sortingTypeCreatedDate" />
          </Button>
        </div>
      </div>


      <ul className={css.itemList}>
        {sortedTransactions.map(toTxItem)}
        {fetchInProgress && (
          <li className={css.listItemsLoading}>
            <IconSpinner />
          </li>
        )}
        {seeMoreBtn}
        {noResults}
      </ul>
    </div>
  );
};

export default SectionBookingListMaybe;
